var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "720",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('vertical-form-table', _vm._b({
    scopedSlots: _vm._u([{
      key: "프로그램",
      fn: function () {
        return [_c('span', {
          staticClass: "page-text--sm"
        }, [_vm._v(" " + _vm._s(_vm.program.subject) + " ")])];
      },
      proxy: true
    }, {
      key: "문의",
      fn: function () {
        var _vm$form, _vm$form$user, _vm$form2, _vm$form2$createdAt, _vm$form2$createdAt$t, _vm$form3, _vm$form3$updatedAt, _vm$form3$updatedAt$t;
        return [_c('div', {
          staticClass: "page-text--sm"
        }, [_c('p', {
          staticClass: "mb-16"
        }, [_vm._v("제목: " + _vm._s(_vm.form.subject))]), _c('p', {
          staticClass: "mb-16"
        }, [_vm._v("내용: " + _vm._s(_vm.form.content))]), _c('v-row', {
          staticClass: "row--small mt-14 font-size-12"
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(" 작성자: " + _vm._s((_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$user = _vm$form.user) === null || _vm$form$user === void 0 ? void 0 : _vm$form$user.name) + " ")]), _vm.form.createdAt ? [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v("·")]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(" 작성일시: " + _vm._s((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : (_vm$form2$createdAt = _vm$form2.createdAt) === null || _vm$form2$createdAt === void 0 ? void 0 : (_vm$form2$createdAt$t = _vm$form2$createdAt.toDateTime) === null || _vm$form2$createdAt$t === void 0 ? void 0 : _vm$form2$createdAt$t.call(_vm$form2$createdAt)) + " ")])] : _vm._e(), _vm.form.updatedAt ? [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v("·")]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(" 갱신일시: " + _vm._s((_vm$form3 = _vm.form) === null || _vm$form3 === void 0 ? void 0 : (_vm$form3$updatedAt = _vm$form3.updatedAt) === null || _vm$form3$updatedAt === void 0 ? void 0 : (_vm$form3$updatedAt$t = _vm$form3$updatedAt.toDateTime) === null || _vm$form3$updatedAt$t === void 0 ? void 0 : _vm$form3$updatedAt$t.call(_vm$form3$updatedAt)) + " ")])] : _vm._e()], 2)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false))], 1), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.resetRepliedAt
    }
  }, [_c('span', [_vm._v(" 답변시간 갱신 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 취소 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.execText) + " ")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }